import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.SideEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.CanvasBasedWindow
import kotlinx.browser.document
import kotlinx.browser.window
import music.jammers.client.shared.app.JammersApp
import music.jammers.client.shared.app.di.sharedModules
import music.jammers.web.di.networkModule
import music.jammers.web.di.settingsModule
import org.jetbrains.skiko.wasm.onWasmReady
import org.koin.core.context.startKoin
import org.w3c.dom.events.Event

private const val POP_STATE = "popstate"

@OptIn(ExperimentalComposeUiApi::class)
fun main(): Unit = onWasmReady {
    CanvasBasedWindow(canvasElementId = "appTarget") {
        SideEffect {
            val appLoader = document.getElementById("appLoader")
            appLoader?.remove()
        }

        startKoin {
            modules(
                settingsModule + networkModule + sharedModules
            )
        }

        val currentPath = remember { mutableStateOf(window.location.pathname) }

        DisposableEffect(Unit) {
            val onPopState: (Event) -> Unit = {
                currentPath.value = window.location.pathname
            }

            window.addEventListener(POP_STATE, onPopState)

            onDispose {
                window.removeEventListener(POP_STATE, onPopState)
            }
        }

        JammersApp()
    }
}